import React, {useContext} from "react";
import "./PageThree.scss";
import { BuildingsContext } from "../../../bContext";

function PageThree() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );

  return (
    <>
    <div className="pageThree">
      <div className="speech-bubble4">
      {switchToEnglish === false ? 
        <p className="first">
          Jeśli chcesz przybliżyć widok, użyj w tym celu przycisków plus, minus oraz niebieskiego kółeczka z białą kropeczką.
        </p>
        :
        <p className="first">
          If you want to zoom in on the view, use the plus, minus and blue circle with a white dot.
        </p>
      }
        <div className="inner-triangle-right4"></div>
      </div>
      <div className="menu-pg4"></div>

      <div>
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageThree;
